import * as React from 'react';
import { useQuery } from 'data-fetching-client';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { H2 } from 'UIComponents/elements/headings';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import { GET_FLOW_LOG_EVENTS, GET_REVISION_FOR_TIMESTAMP } from 'flow-doctor-lib/queries/FlowQueries';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ListBranchDebugContainer from 'flow-doctor-lib/components/actions/ListBranchDebugContainer';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ListBranchDebugPanel = ({
  portalId,
  flowId,
  idempotencyId,
  onClose
}) => {
  const {
    loading: logEventsLoading,
    data: logEventsData,
    error: logEventsError
  } = useQuery(GET_FLOW_LOG_EVENTS, {
    variables: {
      portalId,
      idempotencyId,
      flowId,
      eventTypes: ['ACTION_EXECUTION']
    }
  });
  const actionLogEvent = logEventsData && logEventsData.flowLogEvents.results[0];
  const {
    loading: revisionLoading,
    data: revisionData,
    error: revisionsError
  } = useQuery(GET_REVISION_FOR_TIMESTAMP, {
    variables: {
      portalId,
      flowId,
      timestamp: actionLogEvent && actionLogEvent.timestamp || 0
    },
    skip: !actionLogEvent
  });
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: 700,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "list-branch-debug-panel-close",
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: actionLogEvent && /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "flow-doctor-lib.flows.listBranchDebugPanel.title_jsx",
          elements: {
            ObjectTypeLabel
          },
          options: {
            objectTypeId: actionLogEvent.objectTypeId,
            portalId,
            lowerCase: true
          }
        })
      })
    }), /*#__PURE__*/_jsxs(UIPanelBody, {
      children: [/*#__PURE__*/_jsx(UIAbstractProgress, {
        autoStart: true,
        incrementFactor: 0.5,
        incrementInterval: 100,
        render: ({
          value,
          done
        }) => /*#__PURE__*/_jsx(UINanoProgress, {
          value: logEventsLoading || revisionLoading ? Math.min(value, 80) : value,
          animateOnComplete: done && !(logEventsLoading || revisionLoading)
        })
      }), (logEventsError || revisionsError) && /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.description"
        })
      }), actionLogEvent && revisionData && /*#__PURE__*/_jsx(ListBranchDebugContainer, {
        logEvent: actionLogEvent,
        revision: revisionData.revisionForTimestamp
      })]
    })]
  });
};
export default ListBranchDebugPanel;